export const unleashConfig = {
  url: import.meta.env.VITE_UNLEASH_URL || 'http://localhost:4242/api',
  clientKey: import.meta.env.VITE_UNLEASH_KEY || 'default:development.unleash-insecure-api-token',
  appName: 'unleash-onboarding-react',
  refreshInterval: 120, // Poll for flag updates every 2 minutes (reduced from 60s to lower load)
}
